import { AcquireTokenFunction, BannerProvider } from "@sbb-rsu/ui-banners";
import { bannerEnvironment } from "models/Environment";
import { useAuthentication } from "providers";
import React, { FC, PropsWithChildren } from "react";

export const AppBannerProvider: FC<PropsWithChildren> = ({ children }) => {
  const { acquireTokenSilent } = useAuthentication();

  const acquireToken = React.useCallback<AcquireTokenFunction>(
    async (scopes: string[]) => {
      return await acquireTokenSilent(scopes);
    },
    [acquireTokenSilent]
  );

  return (
    <BannerProvider app="sive" environment={bannerEnvironment} acquireToken={acquireToken}>
      {children}
    </BannerProvider>
  );
};
